import AmbatturChennai from "./AmbatturChennai.vue";
import Bandra from "./Bandra.vue";
import Belapur from "./Belapur.vue";
import Coimbatore from "./Coimbatore.vue";
import DeccanPune from "./DeccanPune.vue";
import Hubballi from "./Hubballi.vue";
import KarveRoadPune from "./KarveRoadPune.vue";
import KolkataOffice from "./KolkataOffice.vue";
import LowerParel from "./Lowerparel.vue";
import MiraRoad from "./MiraRoad.vue";
import OMRChennai from "./OMRChennai.vue";
import PimpliSaudagar from "./PimpliSaudagar.vue";
import Raipur from "./Raipur.vue";
import SolapurHarshada from "./SolapurHarshada.vue";
import SolapurOffice from "./SolapurOffice.vue";
import Thane from "./Thane.vue";
import Vashi from "./Vashi.vue";
import VimanNagar from "./VimanNagar.vue";
import Kalyan from "./Kalyan.vue";
import Sangli from "./Sangli.vue";
export {
  AmbatturChennai as AmbatturChennaiMBBS,
  Bandra as BandraMBBS,
  Belapur as BelapurMBBS,
  Coimbatore as CoimbatoreMBBS,
  DeccanPune as DeccanPuneMBBS,
  Hubballi as HubballiMBBS,
  KarveRoadPune as KarveRoadPuneMBBS,
  KolkataOffice as KolkataOfficeMBBS,
  LowerParel as LowerParelMBBS,
  MiraRoad as MiraRoadMBBS,
  OMRChennai as OMRChennaiMBBS,
  PimpliSaudagar as PimpliSaudagarMBBS,
  Raipur as RaipurMBBS,
  SolapurHarshada as SolapurHarshadaMBBS,
  SolapurOffice as SolapurOfficeMBBS,
  Thane as ThaneMBBS,
  Vashi as VashiMBBS,
  VimanNagar as VimanNagarMBBS,
  Kalyan as KalyanMBBS,
  Sangli as SangliMBBS,
};



// WEBPACK FOOTER //
// ./src/components/pages/MBBSFair/index.js